import { render, staticRenderFns } from "./CollectionManualUserSchedule.vue?vue&type=template&id=c670dda8&scoped=true&"
import script from "./CollectionManualUserSchedule.vue?vue&type=script&lang=js&"
export * from "./CollectionManualUserSchedule.vue?vue&type=script&lang=js&"
import style0 from "./CollectionManualUserSchedule.vue?vue&type=style&index=0&id=c670dda8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c670dda8",
  null
  
)

export default component.exports